<template>

  <v-menu bottom max-width="350" nudge-bottom="5" nudge-left="5" :open-on-click="false" :close-on-click="false" :close-on-content-click="false" content-class="tour-arrow tour-arrow-left purple white--text pt-6 px-4" transition="slide-y-transition" :value="listFilter">
    <template v-slot:activator="{on:tour}">

      <v-menu offset-y :close-on-content-click="false" eager v-model="open">
        <template v-slot:activator="{ on: filter }">
          <v-tooltip top>
            <template v-slot:activator="{ on: tooltip }">
              <v-btn v-on="{...tooltip, ...filter}" icon class="mr-1"><v-icon>mdi-filter-variant</v-icon></v-btn>
            </template>
            Filter the list (/ for quick access)
          </v-tooltip>
        </template>
        <v-card width="300" class="pt-6">
          <slot/>
          <v-list-item>
            <v-btn v-if="includeReset" plain @click="$emit('reset')">Reset</v-btn>
            <v-spacer/>
            <v-btn plain @click="open=false">Close</v-btn>
          </v-list-item>
        </v-card>
      </v-menu>

    </template>
    List contents can be filtered.
    Clicking the filter icon will show a menu that allows filters to be set.
    <div class="mt-2">For quick access to the filter menu, press /</div>
    <div>
      <v-btn plain class="white--text mt-4 float-right" @click.stop="done()">Got it</v-btn>
    </div>
  </v-menu>
</template>

<script>

export default {
  name: 'FilterMenu',
  props: {
    includeReset: {type:Boolean, required:false, default:false},
    noHint: {type:Boolean, required:false, default:false}
  },
  data() {
    return {
      open: false,
    }
  },
  computed: {
    listFilter() {
      return !this.noHint && this.$store.getters.userSettings.filterHint;
    }
  },
  watch: {
    tour() {
      const settings = this.$store.getters.userSettings;
      settings.tour = this.tour;
      this.$store.commit('setUserSettings', settings);
    }
  },
  mounted () {
    document.onkeydown = e => {
      e = e || window.event
      if (e.keyCode === 191 /* Forward Slash '/' */ &&
//          e.target !== this.$refs.textField.$refs.input &&
          !this.$store.state.disableSearchHotKey) {
        e.preventDefault()
        this.$nextTick(() => {
          this.open = true;
        });
      }
    }
  },
  beforeDestroy() {
    document.onkeydown = null
  },
  methods: {
    done() {
      delete this.$store.getters.userSettings.filterHint;
      this.$store.getters.userSettings.listMenuHint = true;
      this.$store.commit('setUserSettings', this.$store.getters.userSettings);
    },
    close() {
      this.open = false;
    }
  }
}
</script>
